<template>
  <section itemscope itemtype="http://schema.org/MediaObject">
    <b-badge v-for="genre in product.genres" :key="genre.id" variant="danger" class="mx-1" itemprop="genre">
      {{ genre.name }}
    </b-badge>
  </section>
</template>

<script>
export default {
  name: 'ProductGenres',
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style scoped>

</style>
